import {IsEmptyVar} from '../defines/common.func';
import {ExampleSJ} from './word.model';
import {SimpleWord} from './simple-word.model';

export class Example {
  id: string;
  postposition: number;
  id1: string;
  id2: string | null;
  example_s: string | null;
  example_t: string | null;
  example_highlight: string | null;
  example_voice: string | null;
  bookmark: boolean;
  word1: SimpleWord | null;
  word2: SimpleWord | null;

  offsetTop?: number;

  constructor(obj?: any) {
    this.id           = (obj && obj.id)           ?? null;
    this.postposition = (obj && obj.postposition) ?? null;
    this.id1          = (obj && obj.id1)          ?? null;
    this.id2          = (obj && obj.id2)          ?? null;
    this.example_s    = (obj && obj.example_s)    ?? null;
    this.example_t    = (obj && obj.example_t)    ?? null;
    this.example_highlight = (obj && obj.example_highlight) ?? null;
    this.example_voice = (obj && obj.example_voice) ?? null;
    this.bookmark     = (obj && !IsEmptyVar(obj.bookmark)) ? !!obj.bookmark : false;
    this.word1        = (obj && obj.word1)        ? new SimpleWord(obj.word1) : null;
    this.word2        = (obj && obj.word2)        ? new SimpleWord(obj.word2) : null;
  }

  public toExampleSJ(): ExampleSJ | null {
    if (!this.example_t) return null;
    return {
      seungjo: this.example_s,
      example: this.example_t,
      highlight: this.example_highlight,
      voiceExIdx: null,
    };
  }
}
